module.exports = __webpack_public_path__ + "img/req_list_960.ca38626e.png";